<script setup lang="ts">
import { useRoute } from 'vue-router'
import { Lock } from '@element-plus/icons-vue'

const route = useRoute()
const backPath = route.query.redirect as string || '/dashboard'
</script>

<template>
  <div class="forbidden-page">
    <div class="forbidden-content">
      <ElIcon size="96" class="forbidden-icon">
        <Lock />
      </ElIcon>
      <h1 class="forbidden-title">403</h1>
      <h2 class="forbidden-heading">暂无权限</h2>
      <p class="forbidden-desc">
        您当前没有访问此页面的权限，请联系管理员为您配置相应权限。
      </p>
      <div class="forbidden-actions">
        <ElButton type="primary" @click="$router.back()">
          返回上一页
        </ElButton>
        <ElButton @click="$router.push(backPath)">
          返回首页
        </ElButton>
      </div>
    </div>
  </div>
</template>

<style scoped>
.forbidden-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: var(--color-bg-page, #f5f7fa);
  padding: 24px;
}

.forbidden-content {
  text-align: center;
  max-width: 480px;
}

.forbidden-icon {
  color: var(--color-warning, #e6a23c);
  margin-bottom: 16px;
}

.forbidden-title {
  font-size: 72px;
  font-weight: 700;
  color: var(--color-text-primary, #303133);
  margin: 0 0 8px;
  line-height: 1;
}

.forbidden-heading {
  font-size: 24px;
  font-weight: 600;
  color: var(--color-text-primary, #303133);
  margin: 0 0 12px;
}

.forbidden-desc {
  font-size: 14px;
  color: var(--color-text-secondary, #606266);
  margin: 0 0 32px;
  line-height: 1.6;
}

.forbidden-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
}
</style>
